import {Middleware, MiddlewareAPI} from "@reduxjs/toolkit";

import {RollbarClient} from "@/lib/utils/rollbar.client";

export const errorLoggingMiddleware: Middleware = (api: MiddlewareAPI) => (next) => (action: any) => {
  try {
    return next(action);
  } catch (error: unknown) {
    RollbarClient.error("An error occurred inside the store:", {
      action: action.type,
      error: error instanceof Error ? error.message : String(error),
    });
  }

  return next(action);
};
